import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LogoRefabric, IconMenuOpen, IconAgent } from "icons";
import { cn } from "utils/cn";
import { useAppDispatch, useAppSelector } from "store";
import { setChatbotOpen } from "store/commonSlice";
import { PATHS } from "router/config/paths";
import { confirmNavigation } from "utils/unsavedChangesGuard";

interface Props {
  onMenuClick: () => void;
}

const MobileTopBar = ({ onMenuClick }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isChatbotOpen = useAppSelector((s) => s.common.isChatbotOpen);

  const goHome = useCallback(async () => {
    if (await confirmNavigation()) navigate(PATHS.HOME);
  }, [navigate]);

  const toggleChatbot = useCallback(() => {
    dispatch(setChatbotOpen(!isChatbotOpen));
  }, [dispatch, isChatbotOpen]);

  return (
    <div className="sticky top-0 z-30 flex items-center gap-3 h-[52px] px-3 border-b border-black-300 bg-black-100">
      <button
        type="button"
        aria-label={t("common:nav.open_menu")}
        className="flex-shrink-0 flex-center w-9 h-9 -ml-1 rounded text-trueBlack dark:text-white hover:bg-black-200 transition-colors"
        onClick={onMenuClick}
      >
        <IconMenuOpen className="w-[20px] h-[20px]" />
      </button>

      <LogoRefabric className="text-trueBlack dark:text-white h-5 cursor-pointer" onClick={goHome} />

      <button
        type="button"
        title={t("chatbot.open_aria")}
        className={cn("ml-auto flex-shrink-0 flex-center w-9 h-9 rounded border border-black-300 text-trueBlack dark:text-white hover:bg-black-200 transition-colors", isChatbotOpen && "bg-black-200")}
        onClick={toggleChatbot}
      >
        <IconAgent className="w-5 h-5" />
      </button>
    </div>
  );
};

export default MobileTopBar;
